// extracted by mini-css-extract-plugin
module.exports = {"drawerSeparator":"Separator-module--drawerSeparator--1Jel6"};